<template>
  <div class="home-wrap">
    <div class="header">
      <img src="@/assets/imgs/形状@2x.png" alt />所有信息仅用于身份验证，我们不会以任何形式收集
    </div>
    <div class="content">
      <div class="title">选择认证方式</div>
      <ul class="authentication-list" ref="authList">
        <li v-if="telephone" class="authentication-item" @click="()=>typeLink(2)">
          <img src="@/assets/imgs/icon_api@2x.png" alt />
          <div class="mid">
            <div class="name">手机号认证</div>
            <div class="des">要求确保该手机号是由本人身份证办理</div>
          </div>
          <div class="right">
            <van-loading v-if="loading" type="spinner" size="16px" />
            <van-icon v-else name="arrow" />
          </div>
        </li>
        <li class="authentication-item" @click="()=>typeLink(1)">
          <img src="@/assets/imgs/icon_real@2x.png" alt />
          <div class="mid">
            <div class="name">人脸识别认证</div>
            <div class="des">需用手机录制一段朗读数字的认证视频</div>
          </div>
          <div class="right">
            <van-loading v-if="loading" type="spinner" size="16px" />
            <van-icon v-else name="arrow" />
          </div>
        </li>
        <li class="authentication-item" @click="()=>typeLink(3)">
          <img src="@/assets/imgs/icon_api@2x(1).png" alt />
          <div class="mid">
            <div class="name">银行卡认证</div>
            <div class="des">需校验本人的银行卡信息及预留手机号</div>
          </div>
          <div class="right">
            <van-loading v-if="loading" type="spinner" size="16px" />
            <van-icon v-else name="arrow" />
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import creditApis from '@/api/creadit'
import { isWxMiniProgram } from '@/utils/ua'
import Api from '@/api'

export default {
  data() {
    return {
      telephone: '',
      listCount: 0,
      loading: false,
      auth_info: {}
    }
  },
  created() {
    this.telephone = this.$store.state.creditMsg.telephone
    try {
      const json = sessionStorage.getItem('auth_info') || {}
      this.auth_info = JSON.parse(json)
    } catch (error) {
      console.log("🚀 ~ error:", error)
      this.$router.back()
    }
  },
  computed: {
    creditMsg() {
      return this.$store.state.creditMsg
    },
    redirectUrl() {
      return `${window.location.origin}/faceverifying`
    },
  },
  mounted() {
    // this.getAuthList()
  },
  methods: {
    goUrl(url) {
      const { redirectUrl } = this.$route.query

      this.$router.push({
        path: url,
        query: {
          redirectUrl
        }
      })
    },

    typeLink(type){
      if(this.loading){
        return
      }
      this.loading = true
      Api.applyCaVerify({
        ...this.auth_info,
        // 身份证号为脱敏信息（含 *）时校验不通过，传 undefined 由后端查库获取完整号码
        idcardNo:
          this.auth_info.idcardNo && this.auth_info.idcardNo.includes('*')
            ? ""
            : this.auth_info.idcardNo,
        verificationMode: type,
        cardType: 0,
        // callBackUrl: `${window.location.origin  }/authenticationSuccess`
        callBackUrl: `${window.location.origin}/faceverifying`
      }).then((doc) => {
        this.loading = false
        window.location.href = doc.url
        console.log("🚀 ~ doc:", doc)

      }).catch(()=>{
        this.loading = false
      })
    }
  },
}
</script>
<style lang="less" scoped>
.home-wrap {
  .header {
    padding: 0 16px;
    display: flex;
    align-items: center;

    img {
      width: 11px;
      height: 14px;
      margin-right: 8px;
    }

    width: 375px;
    height: 40px;
    background: rgba(230, 247, 242, 1);
    font-size: 12px;
    font-family: PingFangSC-Regular,
    PingFang SC;
    font-weight: 400;
    color: rgba(22, 187, 131, 1);
    line-height: 40px;
  }

  .content {
    padding: 16px;

    .title {
      width: 90px;
      height: 24px;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(60, 64, 67, 1);
      line-height: 24px;
      margin-bottom: 16px;
    }

    .authentication-list {
      .authentication-item {
        display: flex;
        align-items: center;
        width: 343px;
        height: 80px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 5px 20px 0px rgba(197, 202, 213, 0.25);
        border-radius: 8px;
        margin-bottom: 16px;
        padding: 0 16px;
        cursor: pointer;

        img {
          width: 48px;
          height: 48px;
          margin-right: 16px;
        }

        .mid {
          flex: 1;

          .name {
            height: 24px;
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(17, 26, 52, 1);
            line-height: 24px;
            margin-bottom: 4px;
          }

          .des {
            height: 20px;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(109, 119, 144, 1);
            line-height: 20px;
          }
        }

        .right {
          width: 14px;
          height: 14px;
          font-size: 14px;
          color: #111a34;
        }
      }

    }
  }
}
</style>
